import React from 'react';
import {
  Search,
  List,
  Header,
  Segment,
  Grid,
  Button,
  Modal,
  Image,
  Table
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import api from '../../../api';
import ResultadosCorpus from '../corpusSearch/ResultadosCorpus';
import CorpusLoader from '../corpusSearch/CorpusLoader';
import '../../../assets/css/utils.css';
import questImg from '../../../assets/img/questImg.png';

class SearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      loading: false,
      loadingCorpusSpinner: false,
      results: [],
      formulas: [],
      colocacion: '',
      renderFormulas: false,
      renderColocaciones: false,
      showEmptyResult: false,
      showCorpusResults: false,
      modalOpen: false,
      data: {
        ejemplos: []
      },
      clasificacionSintacticaResult: [],
      allCategoriesResults: [],
      allUnidadesLexicas: [],
      renderSomeCategory: false,
      someCategoriesResult: [],
      renderCategorias: false,
      clasificacionSintacticaId:0,
      activeItem: -1
    };
  }

  onSearchChange = (e, data) => {
    clearTimeout(this.timerFormulas);
    clearTimeout(this.timerColocaciones);
    clearTimeout(this.timerClasificacion);
    this.setState({
      results: [],
      query: data.value,
      showEmptyResult: false,
        renderCategorias: false,
        renderSomeCategory: false
    });
    this.timerFormulas = setTimeout(this.fetchResults, 1500);
  };

  isFormula = obj =>
    this.state.formulas.filter(formula => formula.texto === obj.result.title)
      .length > 0;

  isColocacion = obj =>
    this.state.colocaciones.filter(
      colocacion => colocacion === obj.result.title
    ).length > 0; 

  onResultSelect = (e, selected) => {
    if (this.isFormula(selected)) {
      this.setState({ 
        renderFormulas: true, 
        renderColocaciones: false,
        renderCategorias: false,
        renderSomeCategory: false
      });
    }
    if (this.isColocacion(selected)) {
    clearTimeout(this.timerClasificacion);
      this.setState({
        renderFormulas: false,
        renderColocaciones: true,
        colocacion: selected.result.title,
        renderCategorias: false,
        renderSomeCategory: false
      });
      this.timerClasificacion = setTimeout(this.fetchClasificationResults, 1);
      this.timerClasificacion = setTimeout(this.fetchAllUnidadesLexicas, 1);
    }
    this.setState({activeItem: -1})
  };

  onCategoryResultClick = (flag, id) => {
    if(flag){
      clearTimeout(this.timerClasificacion);
      this.setState({ 
        renderFormulas: false, 
        renderColocaciones: true,
        renderCategorias: false,
        renderSomeCategory: true
      });
      this.timerClasificacion = setTimeout(this.fetchCategoryByClasificacionResults, 1);
      this.setState({clasificacionSintacticaId: id});
      this.setState({activeItem: id})

    } else {
      clearTimeout(this.timerClasificacion);
      this.setState({ 
        renderFormulas: false, 
        renderColocaciones: true,
        renderCategorias: true,
        renderSomeCategory: false
      });
      this.timerClasificacion = setTimeout(this.fetchAllCategoriesResults, 1);
      this.clasificacionSintacticaId = 0;
      this.setState({activeItem: id})
    }  
  }

  //asigna 1 número a cada fórmula repetida
  resultsWithSuffixes = list => {
    const stringList = list.map(formula => formula.title);
    
    // Containers
    const count = {};
    const firstOccurences = {};

    // Loop through the list
    let item;
    let itemCount;
    for (let i = 0, c = stringList.length; i < c; i++) {
      item = stringList[i];
      itemCount = count[item];
      itemCount = count[item] = itemCount == null ? 1 : itemCount + 1;

      if (itemCount === 2) {
        stringList[firstOccurences[item]] =
          stringList[firstOccurences[item]] + ' (1)';
      }
      if (count[item] > 1) {
        stringList[i] = stringList[i] + ' (' + count[item] + ')';
        
      } else {
        firstOccurences[item] = i;
      }
    }

    // Return
    const result = stringList.map(strFormula => ({
      title: strFormula
    }));
    return result;

  };

  formulasWithSuffixes = list => {
    const stringList = list.map(formula => formula.texto);
    // Containers
    const count = {};
    const firstOccurences = {};

    // Loop through the list

    let item;
    let itemCount;
    for (let i = 0, c = stringList.length; i < c; i++) {
      item = stringList[i];
      itemCount = count[item];
      itemCount = count[item] = itemCount == null ? 1 : itemCount + 1;

      if (itemCount === 2) {
        stringList[firstOccurences[item]] =
          stringList[firstOccurences[item]] + ' (1)';
      }

      if (count[item] > 1) {
        stringList[i] = stringList[i] + ' (' + count[item] + ')';
        
      } else {
        firstOccurences[item] = i;
      }
    }

    // Return
    for (let i = 0; i < list.length; i++) {
      if (!stringList.includes(list[i].texto)) {
        const regexp = new RegExp(list[i].texto + ' \\(\\d*\\)');
        const texto = stringList.find(value => regexp.test(value));
        list[i].texto = texto;
        const index = stringList.indexOf(texto);
        if (index !== -1) stringList.splice(index, 1);
      }
    }
    stringList.length = 0;
    return list;    
  };

  nameExist = (list, name) => list.includes(name);

  // TODO: Añadir endpoint para uqe "No results" devuelva un array vacio en vez de 404
  fetchResults = () => {
    const { query } = this.state;
    if (!query) return;
    this.setState({ loading: true });
    api.search.getResults(query).then(resultados => {
      if (typeof resultados !== 'undefined') {
        if (
          // eslint-disable-next-line operator-linebreak
          resultados.formulas.length === 0 &&
          resultados.colocaciones.length === 0
        ) {
          this.setState({
            showEmptyResult: true,
            showCorpusResults: false,
            renderFormulas: false,
            renderColocaciones: false,
            renderCategorias: false,
            renderSomeCategory: false
          });
        }

        const results = [];
        resultados.colocaciones.forEach(colocacion => {
          results.push({
            title: colocacion
          });
        });
        resultados.formulas.forEach(formula => {
          if(formula.tipoCorpus === "Expertos")
            results.push({
              title: formula.texto
            });
        });

        const resultsWithSuffixes = this.resultsWithSuffixes(results);
        this.formulasWithSuffixes(resultados.formulas);
        this.setState({
          results: resultsWithSuffixes,
          formulas: resultados.formulas,
          colocaciones: resultados.colocaciones,
          loading: false,
          showCorpusResults: false,
        renderCategorias: false,
        renderSomeCategory: false
        });
      } else {
        api.formulas.getFormulaByTexto(query).then(resultadosSoloFormulas => {
          const results = [];
          resultadosSoloFormulas.forEach(formula => {
            if(formula.tipoCorpus === "Expertos")
              results.push({
                title: formula.texto
              });
          });
          const resultsWithSuffixes = this.resultsWithSuffixes(results);
          this.setState({
            results: resultsWithSuffixes,
            formulas: resultadosSoloFormulas,
            showCorpusResults: false,
            loading: false,
        renderCategorias: false,
        renderSomeCategory: false            
          });
        });
      }
    });
  };

  fetchClasificationResults = () => {
    const colocacion = this.state.colocacion;
    this.resetClasificacionSintacticaResult();
    if (!colocacion) return;
    this.setState({ loading: true });
    api.colocaciones.getClasificacionByLema(colocacion).then(resultados => {
      if (typeof resultados !== 'undefined') {
        if (
          // eslint-disable-next-line operator-linebreak
          resultados.length > 0
        ) {
          this.setState({            
            clasificacionSintacticaResult: resultados
          });
        }
      }
       this.setState({ loading: false });
    });
  };

  fetchAllCategoriesResults = () => {
    const colocacion = this.state.colocacion;
    if (!colocacion) return;
    this.setState({ loading: true });
    api.colocaciones.getCategoriesByLema(colocacion).then(resultadosC => {
      if (typeof resultadosC !== 'undefined') {
        if (
          resultadosC.length > 0
        ) {
          this.setState({            
            allCategoriesResults: resultadosC
          });
        }
      }
       this.setState({ loading: false });
    });
  };

  fetchCategoryByClasificacionResults = () => {
    const colocacion = this.state.colocacion;
    if (!colocacion) return;
    this.setState({ loading: true });
    api.colocaciones.getCategoriaByClasificacion(colocacion,this.state.clasificacionSintacticaId).then(resultadosCO => {
      if (typeof resultadosCO !== 'undefined') {
        if (
          resultadosCO.length > 0
        ) {
          this.setState({            
            someCategoriesResult: resultadosCO
          });
        }
      }
       this.setState({ loading: false });
    });
  };

  fetchAllUnidadesLexicas = () => {
    const colocacion = this.state.colocacion;
    if (!colocacion) return;
    this.setState({ loading: true });
    api.colocaciones.getUnidadesLexicas(colocacion).then(resultadosUL => {
      if (typeof resultadosUL !== 'undefined') {
        if (
          resultadosUL.length > 0
        ) {
          this.setState({            
            allUnidadesLexicas: resultadosUL
          });
        }
      }
       this.setState({ loading: false });
    });
  };

  handleClose = () => this.setState({ modalOpen: false });

  handleButtonClick = () => {
    this.setState({ loadingCorpusSpinner: true, showEmptyResult: false });
    this.searchByFormasCombinadas();
  };

  searchByFormasCombinadas = () => {
    // const errors = this.validate(this.state.data);
    // this.setState({ errors });

    // if (Object.keys(errors).length === 0) {      
    api.corpus.getByFormasCombinadas(this.state.query, 500, 0).then(frases => {
      if (frases.length === 0) {
        this.setState({
          modalOpen: true,
          data: { ...this.state.data, ejemplos: [], sinResultados: true },
          loadingCorpusSpinner: false,
        renderCategorias: false,
        renderSomeCategory: false
        });
        return;
      }
      const ejemplos = [];
      frases.forEach(element => {
        const ejemplo = {
          fraseAnterior: {
            id: parseInt(element.id, 10) - 1,
            texto: element.fraseanterior
          },
          fraseActual: {
            id: parseInt(element.id, 10),
            texto: element.frase,
            highlight: element.forma
          },
          fraseSiguiente: {
            id: parseInt(element.id, 10) + 1,
            texto: element.frasesiguiente
          }
        };
        ejemplos.push(ejemplo);
      });
      if (ejemplos.length > 0) {
        this.setState({
          data: {
            ...this.state.data,
            ejemplos,
            sinResultados: false,
            value: this.state.query,
        renderCategorias: false,
        renderSomeCategory: false
          }
        });
      } else {
        this.setState({
          data: {
            ...this.state.data,
            ejemplos: [],
            sinResultados: true,
        renderCategorias: false,
        renderSomeCategory: false
          }
        });
      }
      this.setState({
        showCorpusResults: true,
        showEmptyResult: false,
        loadingCorpusSpinner: false,
        renderCategorias: false,
        renderSomeCategory: false
      });
    });
    // }
  };

  resetClasificacionSintacticaResult = () => {
    this.setState({ clasificacionSintacticaResult: [] });
  }

  render() {
    const {
      query,
      results,
      loading,
      formulas,
      renderFormulas,
      renderColocaciones,
      showEmptyResult,
      showCorpusResults,
      renderCategorias,
      clasificacionSintacticaResult,
      allCategoriesResults,
      renderSomeCategory,
      someCategoriesResult,
      allUnidadesLexicas
    } = this.state;

    let glosasAll = new Set();
    let filteredAll = allCategoriesResults.filter(item => 
    !glosasAll.has(item.glosa) && glosasAll.add(item.glosa));
    
    let glosasSome = new Set()
    let filteredSome = someCategoriesResult.filter(item => 
    !glosasSome.has(item.glosa) && glosasSome.add(item.glosa));

    let urlDice = `http://www.dicesp.com/consultageneral/unidadeslexicas/lema:${this.state.colocacion}`;

    return (
      <div>
        <Modal
          header="Corpus"
          content={`"${query}" no se encuentra en el corpus!`}
          open={this.state.modalOpen}
          onClose={this.handleClose}
          actions={[{ key: 'done', content: 'Aceptar', positive: true }]}
        />
        <Grid>
          <Grid.Column textAlign="right" verticalAlign="middle" width="6">
            <Search
              placeholder="Introduce una expresión académica"
              value={query}
              onSearchChange={this.onSearchChange}
              onResultSelect={this.onResultSelect}
              results={results}
              showNoResults={false}
              loading={loading}
            />                         
          </Grid.Column>
          <Grid.Column textAlign="left" verticalAlign="middle" width="2">
            <Image 
              src={questImg} 
              as='a' 
              size='medium' 
              href='https://www.youtube.com/watch?v=uzU9LdXgcfU' 
              target='blank_' 
              avatar
              className="mystyle8"
            />
          </Grid.Column> 
          <Grid.Column width="8">
            <Header as="h3" block attached="top" textAlign="center">
              ¿Qué puedo buscar aquí?
            </Header>
            <Segment attached>
              <List bulleted>
                <List.Item>
                  Una colocación, a partir de un nombre como p. ej.
                  <b>
                    <i> análisis</i>
                  </b>
                  <List.Item className="harta-list-item-style-second-level">
                    análisis + adjetivo:
                    <b>
                      <i> análisis</i>
                    </b>
                    <i> 
			<a href="http://www.dicesp.com:8083/search/colocacionescolocativos/an%C3%A1lisis&descriptivo&descriptivo&~%20+%20adjetivo&2" target="_blank" rel="noopener noreferrer">
                        &nbsp;descriptivo
                      </a>,
			<a href="http://www.dicesp.com:8083/search/colocacionescolocativos/an%C3%A1lisis&profundo&profundo&~%20+%20adjetivo&2" target="_blank" rel="noopener noreferrer">
                        &nbsp;profundo
                      </a>
		    </i>.
                  </List.Item>
                  <List.Item className="harta-list-item-style-second-level">
                    análisis + verbo:
                    <b>
                      <i> el análisis</i>
                    </b>
                    <i>
                        <a href="http://www.dicesp.com:8083/search/colocacionescolocativos/an%C3%A1lisis&indicar&indicar&~%20+%20verbo&4" target="_blank" rel="noopener noreferrer">
                        &nbsp;indica
                      </a>,
                        <a href="http://www.dicesp.com:8083/search/colocacionescolocativos/an%C3%A1lisis&mostrar&mostrar&~%20+%20verbo&4" target="_blank" rel="noopener noreferrer">
                        &nbsp;muestra
                      </a>,
                        <a href="http://www.dicesp.com:8083/search/colocacionescolocativos/an%C3%A1lisis&revelar&revelar&~%20+%20verbo&4" target="_blank" rel="noopener noreferrer">
                        &nbsp;revela
                      </a></i>.
                  </List.Item>
                  <List.Item className="harta-list-item-style-second-level">
                    verbo + análisis:
                    <i>
			<a href="http://www.dicesp.com:8083/search/colocacionescolocativos/an%C3%A1lisis&efectuar&efectuar&verbo%20+%20~&3" target="_blank" rel="noopener noreferrer">
                        &nbsp;efectuar
                      </a>,
                        <a href="http://www.dicesp.com:8083/search/colocacionescolocativos/an%C3%A1lisis&hacer&hacer&verbo%20+%20~&3" target="_blank" rel="noopener noreferrer">
                        &nbsp;hacer
                      </a>,
                        <a href="http://www.dicesp.com:8083/search/colocacionescolocativos/an%C3%A1lisis&realizar&realizar&verbo%20+%20~&3" target="_blank" rel="noopener noreferrer">
                        &nbsp;realizar
                      </a>
                      <b> un análisis</b>.
                    </i>
                  </List.Item>
                </List.Item>
                <List.Item className="harta-list-item-style-first-level">
                  Una fórmula de varias palabras recurrentes en el discurso
                  académico
                  <p className="harta-list-item-style-second-level">
                    p.ej.
                    <i>
                      <a href="http://www.dicesp.com:8083/search/formulas/5200" target="_blank" rel="noopener noreferrer">
                        &nbsp;en el presente estudio,
                      </a>
                      <a href="http://www.dicesp.com:8083/search/formulas/5093" target="_blank" rel="noopener noreferrer">
                        &nbsp;se puede concluir que,
                      </a>
                      <a href="http://www.dicesp.com:8083/search/formulas/5776" target="_blank" rel="noopener noreferrer">
                        &nbsp;en lo que respecta a
                      </a>
                    </i>
                  </p>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
        </Grid>

        {this.state.loadingCorpusSpinner && <CorpusLoader />}
        {showEmptyResult && (
          <Header as="h3" block attached="top">
            No se encuentran resultados
          </Header>
        )}
        {showEmptyResult && (
          <Segment attached>
            &quot;<b>{query}</b>&quot; no se encuentra en HARTA. Puedes realizar
            una búsqueda en Corpus.&nbsp;&nbsp;
            <Button onClick={this.handleButtonClick}>Búsqueda en Corpus</Button>
          </Segment>
        )}
        {showCorpusResults && (
          <Segment>
            <Segment secondary textAlign="center">
              <h3>Búsqueda en Corpus:</h3>
              {this.state.data.ejemplos.length === 1 ? (
                <div>
                  Se ha encontrado <b>{this.state.data.ejemplos.length} </b>
                  resultado
                </div>
              ) : (
                <div>
                  Se han encontrado <b>{this.state.data.ejemplos.length} </b>
                  resultados
                </div>
              )}
            </Segment>
            <ResultadosCorpus
              data={this.state.data}
              radioValue="formasCombinadas"
            />
          </Segment>
        )}

        {renderFormulas && (
          <Header as="h3" block attached="top">
            Fórmulas
          </Header>
        )}
        {renderFormulas && (
          <Segment attached>
            <List>
              {formulas.map(formula => {
                 //if(formula.tipoCorpus == "Expertos"){
                  return (
                    <List.Item
                      key={formula.id}
                      as={Link}
                      target="_blank"
                      to={`/search/formulas/${formula.id}`}
                    >
                      {formula.texto}
                    </List.Item>
                  )  
                 //}
              })}
            </List>
          </Segment>
        )}

        {renderColocaciones && (
          <Header as="h3" block attached="top">
            Colocaciones
          </Header>
        )}
        {renderColocaciones && (
          <Segment attached>
            Ver colocaciones para: <b>{this.state.colocacion}</b>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>         
            {clasificacionSintacticaResult.length > 0 ? ( 
              <>
            <span
              onClick={this.onCategoryResultClick.bind(this,false,null)}
              target="_blank"
              className={this.state.activeItem === null ? 'mystyle10 active' : 'mystyle10'}                  
            >
              Ver todas
            </span>          
            {clasificacionSintacticaResult.map(formula => {
              return (
                <>
                <span key={formula.id}>&nbsp;|&nbsp;
                  <span
                    key={formula.id}
                    onClick={this.onCategoryResultClick.bind(this, true, formula.id)}
                    target="_blank"
                    className={this.state.activeItem === formula.id ? 'mystyle10 active' : 'mystyle10'}
                  >
                  {formula.descripcion.replace('~', this.state.colocacion)}
                  </span>
                </span>
                </>
                  )  
                })}
              </>
            ): <span>La información sobre este lema no está disponible</span>}

            { /*allUnidadesLexicas.length > 1 ?*/ 
            <span>&nbsp;&nbsp;<span>
                <a href={urlDice} target="_blank" className={'mystyle15'}>+ info</a>
              </span></span> 
                /*: ''*/}   
          </Segment>
        )}
        {renderCategorias && (
          <Segment attached>
          <Table fixed>
            <Table.Header><Table.Row><Table.HeaderCell>Glosa</Table.HeaderCell><Table.HeaderCell>Colocativos</Table.HeaderCell></Table.Row></Table.Header>
            <Table.Body>
            {filteredAll.map(glosa => {
                return (
                  <Table.Row key={glosa.id}>
                    <Table.Cell>{glosa.glosa}</Table.Cell>
                    <Table.Cell>                    
                    {allCategoriesResults.map(category => {
                      if(glosa.glosa === category.glosa){
                        return (
                          <List key={category.id} horizontal>
                            <List.Item
                              key={category.id}
                              as={Link}
                              target="_blank"
                              to={`/search/colocacionescolocativos/${this.state.colocacion}&${category.categoria}&${category.sintagma}&${category.descripcion}&${category.clasificacionsintactica_id}`}
                              className={'mystyle11'}
                            >
                              {category.sintagma}
                            </List.Item>
                          </List>
                        )
                    }})}
                    </Table.Cell>
                  </Table.Row>
                )  
            })}
            </Table.Body>
          </Table>
          </Segment>
        )}
        {renderSomeCategory && (
          <Segment attached>
          <Table fixed>
            <Table.Header><Table.Row><Table.HeaderCell>Glosa</Table.HeaderCell><Table.HeaderCell>Colocativos</Table.HeaderCell></Table.Row></Table.Header>
            <Table.Body>
            {filteredSome.map(glosa => {
                return (
                  <Table.Row key={glosa.id}>
                    <Table.Cell>{glosa.glosa}</Table.Cell>
                    <Table.Cell>                    
                    {someCategoriesResult.map(category => {
                      if(glosa.glosa === category.glosa){
                        return (
                          <List key={category.id} horizontal className={'mystyle11'}>
                            <List.Item
                              key={category.id}
                              as={Link}
                              target="_blank"
                              to={`/search/colocacionescolocativos/${this.state.colocacion}&${category.categoria}&${category.sintagma}&${category.descripcion}&${category.clasificacionsintactica_id}`}
                              className={'mystyle11'}
                            >
                              {category.sintagma}
                            </List.Item>,&nbsp;&nbsp;
                          </List>
                        )
                    }})}
                    </Table.Cell>
                  </Table.Row>
                )  
            })}
            </Table.Body>
          </Table>
          </Segment>
        )}
      </div>
    );
  }
}

export default SearchPanel;
